import React, { useState, useEffect } from 'react';

import Dropdown from 'react-bootstrap/Dropdown';
import DropdownToggle from '../../../presentation/dropdown/DropdownToggle';
import DropdownMenu from '../../../presentation/dropdown/DropdownMenu';

import './DropdownCustomLabel.css';

const InputText = React.memo(props=>{
  return (
    <input
      name={props.name}
      type="text"
      className="optBox"
      id={props.id}
      size={props.size}
      placeholder={props.placeholder}
      onChange={props.onChange}
      value={props.value}
      onClick={props.onClick}
    />
  )
})

const DropdownCustomLabel = (props) => {
  const [customName, setCustomName] = useState('');
  const [labelName, setLabelName] = useState('');
  const [labelID, setLabelID] = useState(0);

  useEffect(()=>{
    if (!props.customLabel){
    }
    else{
      if (!props.customLabel.labelID){
        setCustomName(props.customLabel.customName)
      }
      else{
        setCustomName(props.customLabel.customName)
        setLabelID(props.customLabel.labelID)
        setLabelName(props.customLabel.labelName)
      }
    }
  }, [props.customLabel])

  const handleSaveBtn = () => {
    props.handleTooltip(true);
    props.handleSaveBtn(customName, labelName, labelID);
    setCustomName('');
    setLabelName('');
    setLabelID(0);  
  }

  return (
    // <Dropdown id="custom-save">
    <Dropdown id="custom-save" style={{paddingTop:'7px', display:'inline-block'}}>
      <Dropdown.Toggle hrefValue="" as={DropdownToggle} id="custom-save-toggle">
        <div ref={props.tooltipRef} onClick={()=>props.handleTooltip(false)} className="button purple_line">{props.toggle}</div>
      </Dropdown.Toggle>
      <Dropdown.Menu as={DropdownMenu}>
        <div className="option_customName">
          <div className="optionSetting1">
            <ul className="optSetList">
              <li>
                <strong>커스텀</strong>&nbsp;&nbsp;&nbsp;
                <InputText
                  name="custom"
                  id="custom-textfield"
                  size={23}
                  placeholder="커스텀 명을 입력하세요"
                  onChange={(e)=>setCustomName(e.target.value)}
                  value={customName}
                />
              </li>
              <li>
                <strong>그룹</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <InputText
                  name="group"
                  id="group-textfield"
                  size={23} 
                  placeholder="그룹 명을 입력하세요"
                  onChange={(e)=>setLabelName(e.target.value)}
                  value={labelName}
                  onClick={()=>{setLabelID(0)}}
                />
              </li>
              <li style={{display: "flex"}}>
                <strong>내 그룹</strong>&nbsp;&nbsp;
                <div className="labelBox">
                  {props.userLabelData.filter((item) =>!labelName || item.name.toLowerCase().startsWith(labelName.toLowerCase())).map(
                    (item)=>{
                      return(
                        <div className="labelBoxLabels" name={item.name} labelID={item.labelID} onClick={(e)=>{
                          setLabelName(e.target.getAttribute('name'));
                          setLabelID(e.target.getAttribute('labelID'));
                          }}>
                          {item.name}
                        </div>
                      )
                    }
                  )}
                  {!props.userLabelData.filter((item) =>!labelName || item.name.toLowerCase().startsWith(labelName.toLowerCase())).length
                    && <div className="labelBoxLabels">일치하는 그룹이 없습니다.</div>}
                </div>
              </li>
            </ul>
          </div>
        </div>
        <Dropdown.ItemText className="optionSettingBtn">
          <Dropdown.Item style={{width: "auto"}} className="button purple_line">취소</Dropdown.Item>
          &nbsp;
          <Dropdown.Item style={{width: "auto"}} className="button purple_line"
          onClick={()=>handleSaveBtn()}>확인</Dropdown.Item>
        </Dropdown.ItemText>
      </Dropdown.Menu>
    </Dropdown>
  )

}

export default DropdownCustomLabel; 